import '../../../node_modules/normalize-css/normalize.css'
import '../../../Styles/main.scss'

document.addEventListener('DOMContentLoaded', function () {

  // Primary navigation
  const primaryNav = document.querySelectorAll('.Nav__Primary__Item')

  function menuToggle(e) {
      const isToggle = e.target.getAttribute('href')
      const isActive = e.target.classList.contains('js-active')
      const isParentActive = e.target.parentElement.classList.contains('active')

    if (!isToggle || isToggle === '#') {

      for (let x = 0; x < primaryNav.length; x++) {
          if (primaryNav[x] !== e.target) {
              primaryNav[x].classList.remove('js-active')
              primaryNav[x].parentElement.classList.add('js-inactive')

              if (primaryNav[x].getAttribute("aria-expanded") != null) {
                primaryNav[x].setAttribute("aria-expanded", "false")
              }
          }        
      }
        if (e.target.getAttribute("aria-expanded") != null) {
            if (!isParentActive || e.target.getAttribute("aria-expanded") != "true") {
                e.target.setAttribute("aria-expanded", !isActive);
            }
        }

        e.target.classList.toggle('js-active', !isActive)
        e.target.parentElement.classList.toggle('js-inactive', !isActive)

      e.preventDefault()
    }

  }

  for (let x = 0; x < primaryNav.length; x++) {
    primaryNav[x].addEventListener('click', menuToggle)
  }


  // Mobile menu toggle
  const mobileMenu = document.querySelector('.Nav__Primary')
  const mobileMenuToggle = document.querySelector('.App__Mobile__Menu')
  const headerToolbar = document.querySelector('.App__Mobile__Toolbar')
  const appBody = document.querySelector('.App__Body')
  const appBottom = document.querySelector('.App__Bottom')
  const mobileImagesSection = document.querySelector('.App__Mobile__Banners')

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', function (e) {
        mobileMenu.classList.toggle('js-active')
        toggleAttribute(mobileMenuToggle, "aria-expanded", "true", "false")
        toggleAttribute(headerToolbar, "aria-hidden", "true", "false")
        toggleAttribute(appBody, "aria-hidden", "true", "false")
        toggleAttribute(appBottom, "aria-hidden", "true", "false")
        toggleAttribute(mobileImagesSection, "aria-hidden", "true", "false")
    }, false)
  }

    function toggleAttribute(elem, attributeName, onStateValue, offStateValue) {
        if (elem.getAttribute(attributeName) == null || elem.getAttribute(attributeName) == offStateValue)
            elem.setAttribute(attributeName, onStateValue)
        else
            elem.setAttribute(attributeName, offStateValue)
    }
}, false)